import React, { useState } from 'react';
import { Container, TextField, Button, Grid, Box, Typography } from '@mui/material';
import { ForgotPassword as ForgotPasswordAPI, ResetPassword } from '../../../api';
import { useParams, useNavigate } from 'react-router-dom';
import { validate } from 'validate.js';
import constraints from '../validate-email-constraints';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [success, setSuccess] = useState(false);

  const { uid, hash } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitError(false);
    if (hash) {
      ResetPassword({ uid, password, hash })
        .then(() => navigate('/'))
        .catch(e => setSubmitError(e.response?.data?.errors || e.message));
    } else {
      const emailAddress = email.toLowerCase().trim();
      const validation = validate({ emailAddress }, constraints);
      if (validation) return setSubmitError(validation.emailAddress);
      ForgotPasswordAPI(emailAddress)
        .then(() => setSuccess(true))
        .catch(e => setSubmitError(e.response?.data?.errors || e.message));
    }
  };

  if (success)
    return <Typography>A password reset link was sent to the email address.</Typography>;

  return (
    <Container>
      <Typography component="h1" variant="h4">Forgot Password</Typography>
      {submitError && <Typography component="p" color="error">{submitError}</Typography>}
      <form onSubmit={handleSubmit}>
        {hash ? (
          <>
            <TextField sx={{ marginTop: 1 }} value={password} name="password" type="password" fullWidth required label="Password" autoComplete="false" onChange={e => setPassword(e.target.value)} />
            <TextField sx={{ marginTop: 1 }} value={confirmPassword} name="confirmPassword" type="password" fullWidth required error={confirmPasswordInvalid} label="Confirm Password" autoComplete="false" onChange={e => { setConfirmPassword(e.target.value); setConfirmPasswordInvalid(password !== e.target.value); }} />
          </>
        ) : (
          <TextField sx={{ marginTop: 1 }} value={email} name="email" fullWidth required label="Email address" onChange={e => setEmail(e.target.value)} />
        )}
        <Grid container justifyContent="center">
          <Box mt={5} mb={5}>
            <Button variant="contained" color="primary" type="submit">Submit</Button>
          </Box>
        </Grid>
      </form>
    </Container>
  );
};

export default ForgotPassword;
